<script>
import DashboardSelector from "@/components/modules/new-dashboard/dashboard-selector.vue";
import TrackerDashboardFilters from "@/components/modules/tracker-dashboard/components/tracker-dashboard-filters.vue";
import {mapGetters} from "vuex";

export default {
  components: {TrackerDashboardFilters, DashboardSelector},
  data: function () {
    return {
      selectedTracker: null,
      modalShow: false,
      perPage: 30,
      currentPage: 1,
      fields: [
      ],
      tableData: [],
      searchTerm: '',
      sortBy: 'organizationName',
      sortDesc: false,
    }
  },
  computed: {
    ...mapGetters(['getTrackerAll',"getLang"]), rows() {
      return this.tableData.length
    }
  },
  mounted() {
    this.setFields();
    this.formatTrackers();
  },
  methods: {
    formatTrackers: function () {
      this.tableData = this.getTrackerAll.data.filter(
        tracker=> tracker.organizationName.toLowerCase().includes(this.searchTerm.toLowerCase()),
      );
    },
    selectTracker:function(tracker){
      this.selectedTracker = tracker;
      this.modalShow = true;
    },
    closeModal: function () {
      this.selectedTracker = null;
      this.modalShow = false;
    },
    setFields: function () {
      this.fields = [
        {
          key: "organizationName",
          label: this.$t('label_tracker_table_header_companies'),
          sortable: true,
          thStyle: {width: '35%',},
        },
        {key: "view", label: '', sortable: false},
        {key: "countryObj", label: this.$t('label_tracker_table_header_country'), sortable: true,},
        {key: "certificationYear", label: this.$t('label_tracker_table_header_year'), sortable: true,},
        {key: "size", label: this.$t('label_tracker_table_header_size'), sortable: true,},
        {key: "certificationStandard", label: this.$t('label_tracker_table_header_certificationStandard'), sortable: true,},
      ]
    }
  },
  watch: {
    getTrackerAll: {
      handler: function () {
        this.formatTrackers();
      },
      deep: true
    },
    getLang: function () {
      this.setFields()
    }
  }
}
</script>

<template>
  <div style="position: relative; ">

    <b-modal v-model="modalShow" hide-footer hide-header centered >
      <div v-if="selectedTracker">
        <div class="tracker-modal-header">{{selectedTracker.organizationName}}</div>
        <div class="tracker-modal-body-container">
        <div class="tracker-modal-body"><span class="tracker-modal-label">{{$t('label_tracker_dashboard_modal_region')}}</span>: <span class="tracker-modal-value">{{$t(selectedTracker.region.region)}}</span></div>
        <div class="tracker-modal-body"><span class="tracker-modal-label">{{$t('label_tracker_dashboard_modal_country')}}</span>: <span class="tracker-modal-value">{{$t(selectedTracker.countryObj.country)}}</span></div>
        <div class="tracker-modal-body"><span class="tracker-modal-label">{{$t('label_tracker_dashboard_modal_sector')}}</span>: <span class="tracker-modal-value">{{$t(selectedTracker.sector)}}</span></div>
        <div class="tracker-modal-body"><span class="tracker-modal-label">{{$t('label_tracker_dashboard_modal_economicActivity')}}</span>: <span class="tracker-modal-value">{{$t(selectedTracker.economyActivity)}}</span></div>
        <div class="tracker-modal-body"><span class="tracker-modal-label">{{$t('label_tracker_dashboard_modal_organizationType')}}</span>: <span class="tracker-modal-value">{{$t(selectedTracker.typeOfOrganization)}}</span></div>
        <div class="tracker-modal-body"><span class="tracker-modal-label">{{$t('label_tracker_dashboard_modal_size')}}</span>: <span class="tracker-modal-value">{{$t(selectedTracker.size)}}</span></div>
        <div class="tracker-modal-body"><span class="tracker-modal-label">{{$t('label_tracker_dashboard_modal_numberOfCertifiedCities')}}</span>: <span class="tracker-modal-value">{{selectedTracker.certifiedCities}}</span></div>
        <div class="tracker-modal-body"><span class="tracker-modal-label">{{$t('label_tracker_dashboard_modal_femaleEmployees')}}</span>: <span class="tracker-modal-value">{{selectedTracker.femaleEmployees}}</span></div>
        <div class="tracker-modal-body"><span class="tracker-modal-label">{{$t('label_tracker_dashboard_modal_maleEmployess')}}</span>: <span class="tracker-modal-value">{{selectedTracker.maleEmployees}}</span></div>
        <div class="tracker-modal-body"><span class="tracker-modal-label">{{$t('label_tracker_dashboard_modal_certificationYear')}}</span>: <span class="tracker-modal-value">{{selectedTracker.certificationYear}}</span></div>
        <div v-if="selectedTracker.certificationStandard" class="tracker-modal-body"><span class="tracker-modal-label">{{$t('label_tracker_dashboard_modal_certificationStandard')}}</span>: <span class="tracker-modal-value">{{$t(selectedTracker.certificationStandard)}}</span></div>
        </div>
      </div>
    </b-modal>
    <div class="search-container">
      <div class="total-companies">{{ $t('label_tracker_total_companies') }}: <span
        class="total-companies-value">{{ tableData.length }}</span></div>
      <div>
        <b-input-group>
          <template #append>
                    <span class="tracker-search-icon"
                    ><icon
                      class="fa-icon-nuevo"
                      name="search"
                      aria-hidden="true"
                    /></span>
          </template>
          <b-form-input
            v-model="searchTerm"
            class="input-search-trackers"
            type="text"
            @input="formatTrackers()"
            :placeholder="
                      $t('label_tracker_dashboard_search_placeholder')
                    "
          />
        </b-input-group>
      </div>
    </div>
    <div class="tracker-table-container">
      <b-table
        show-empty
        striped
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :fields="fields"
        :items="tableData"
        :per-page="perPage"
        :current-page="currentPage"
      >
        <template #cell(organizationName)="data">
          <div class="organization-name-table"> {{ data.item.organizationName }}</div>
        </template>
        <template #head(organizationName)="data">
          <span class="organization-name-table-header"> {{ data.label }}</span>
        </template>
        <template #cell(view)="data">

          <div class="organization-name-table" style="text-align: center;" @click="selectTracker(data.item)">
            <icon
              style="cursor: pointer"
              class="fa-icon-nuevo"
              name="eye"
              aria-hidden="true"
            />
          </div>
        </template>
        <template #head()="data">
          <span class="tracker-table-header"> {{ $t(data.label) }}</span>
        </template>
        <template #cell(countryObj)="data">
          {{ $t(data.item.countryObj.country) }}
        </template>
        <template #cell(size)="data">
          {{ $t(data.item.size) }}
        </template>

        <template #cell(certificationStandard)="data">
          {{ $t(data.item.certificationStandard) }}
        </template>
      </b-table>
      <b-pagination
        align="right"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<style scoped lang="scss">
.tracker-tabs-container {
  display: flex;
  gap: 20px;
  justify-content: center;

  > * {
    background-color: #716C6E;
    padding: 5px;
    min-width: 200px;
    text-align: center;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    font-family: Montserrat-Bold, sans-serif;
    font-size: 14px;
    color: white;
    cursor: pointer;
  }

  align-items: end;
  height: 100%;
}

.tracker-selected {
  background-color: #19a39c !important;
}

.tracker-table-container {
  padding: 10px 50px 20px;
}

.search-container {
  padding: 20px 50px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.total-companies {
  color: #4F4E4E;
  font-family: Montserrat-Regular, sans-serif;
  font-size: 20px;
}

.total-companies-value {
  color: #2F60A6;
  font-family: Montserrat-Bold, sans-serif;
  font-size: 20px;
}

.tracker-search-icon svg {
  fill: #1E4380 !important;
  height: 22px;
  width: 22px;
}

.input-group {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  width: 500px;
  border-radius: 9px;
  border: none
}

.tracker-table-header {
  color: #273A76;
  font-family: Poppins-Regular, sans-serif;
  font-size: 20px;
}

.organization-name-table {
  color: #273A76;
  font-family: Montserrat-Regular, sans-serif;
  padding-left: 20px;
}

.organization-name-table-header {
  padding-left: 20px;
  color: #273A76;
  font-family: Poppins-Regular, sans-serif;
  font-size: 20px;
}

.tracker-table-container {
  table {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 8px;
  }
}

.tracker-modal-label {
  color: #322C2E;
}
.tracker-modal-value {
  color: #322C2E;
  font-family: Montserrat-Bold, sans-serif;
}
.tracker-modal-body-container {
  text-align: left;
  padding: 0 40px 40px;
}
.tracker-modal-header{
  padding-bottom: 30px;
}
</style>
<style lang="scss">
.tracker-table-container .table th, .tracker-table-container .table td {
  border: none !important;
}

.tracker-table-container .table td {
  color: #322C2E;
  font-family: Montserrat-Regular, sans-serif;
}

.tracker-table-container .table-striped tbody tr:nth-of-type(odd) {
  background-color: #EBECE4;
}
.tracker-modal-header{
  text-align: left;
  font-family: Montserrat-Bold, sans-serif;
  font-size: 20px;  color: #273A76;
  text-align: center;
}
</style>
